import React, { memo } from "react";
import BaseSwingTable from "../../swing_library/components/Table/BaseSwingTable";
import { useSwingList } from "../../swing_library/hooks/useSwingList";
import { useUpdateCollection } from "../hooks/useUpdateCollection";
import { useSwingTableColumns } from "../../swing_library/hooks/useSwingTableColumns";
import { useCollectionActions } from "../hooks/useCollectionActions";

function AddSwingsTable({ collection }) {
  const { data: swingListData, isLoading } = useSwingList();
  const updateCollectionMutation = useUpdateCollection();
  const { addSwingToCollection, isSwingInCollection } = useCollectionActions({
    collection,
    updateCollection: updateCollectionMutation.mutateAsync,
  });

  const columns = useSwingTableColumns({
    collectionVideoIds: collection?.videoIds,
    onVideoAction: addSwingToCollection,
    videoPathAction: "add",
  });

  // Add opacity for items already in collection
  const getRowClassName = (row) => {
    const videoId = row.original?.id;
    const isInCollection = isSwingInCollection(videoId);
    return isInCollection ? "opacity-50" : "";
  };

  return (
    <BaseSwingTable
      allVideos={swingListData?.videos || []}
      columns={columns}
      averages={swingListData?.averages}
      enableRowSelection={true}
      getRowClassName={getRowClassName}
      isLoading={isLoading}
      showPagination={true}
      tableClassName="rounded-t-xl"
    />
  );
}

export default memo(AddSwingsTable);
